import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiIJsselsteinEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="IJsselstein"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={87.50}
      distance="72 km"
      duration="55-60 minuten"
    />
  );
}
